import { QueryResult, useQuery } from '@apollo/client';
import React, { createContext } from 'react';
import { getNotifications } from 'vendor-marketplace-shared-library';

import useAuth from '../hooks/useAuth';

export type NotificationsContextParams = {
  notificationsQuery: QueryResult;
};

export const NotificationsContext = createContext({} as NotificationsContextParams);

export default function NotificationsProvider(props: { children: React.ReactNode }) {
  const { accessToken } = useAuth();
  const notificationsQuery = useQuery(getNotifications, {
    pollInterval: 60000 * 5, // 5 minutes
    skip: !accessToken,
  });

  return (
    <NotificationsContext.Provider value={{ notificationsQuery }}>
      {props.children}
    </NotificationsContext.Provider>
  );
}
